import React, { useEffect, useState } from "react";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import api from "../lib/api";

export default function Contact() {
  const [c, setC] = useState({ address: "Plebiscytowa 15, 40-035 Katowice", phone: "", email: "", description: "", map_url: "", hours: [] });
  useEffect(() => {
    api.get("/contact").then((r) => setC({ ...r.data, hours: r.data.hours || [] }));
  }, []);

  const mapSrc = c.map_url || "https://www.google.com/maps?q=Plebiscytowa+15,+Katowice&output=embed";

  return (
    <div data-testid="contact-page" className="bg-[#2A2A2A] min-h-screen">
      <header className="bg-[#1F1F1F] border-b border-[#3a3a3a] py-20">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10">
          <div className="kicker mb-5">Kontakt</div>
          <h1 className="font-display text-white text-3xl sm:text-5xl md:text-7xl uppercase leading-[0.9]">
            Wpadnij<br/><span className="text-[#FFCC00]">na kawę i majsterkowanie</span>
          </h1>
        </div>
      </header>

      <section className="py-16 md:py-24">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2 space-y-6">
            <p className="text-white/80 text-lg leading-relaxed" data-testid="contact-description">{c.description}</p>

            <ul className="space-y-5">
              <li className="flex items-start gap-4 border-t border-[#3a3a3a] pt-5" data-testid="contact-address">
                <MapPin className="text-[#FFCC00] flex-shrink-0 mt-1" size={22}/>
                <div>
                  <div className="font-mono-acc text-[10px] uppercase text-white/50 mb-1">Adres</div>
                  <div className="font-display text-white text-lg uppercase">{c.address}</div>
                </div>
              </li>
              {c.phone && (
                <li className="flex items-start gap-4 border-t border-[#3a3a3a] pt-5" data-testid="contact-phone">
                  <Phone className="text-[#FFCC00] flex-shrink-0 mt-1" size={22}/>
                  <div>
                    <div className="font-mono-acc text-[10px] uppercase text-white/50 mb-1">Telefon</div>
                    <div className="font-display text-white text-lg whitespace-pre-wrap">{c.phone}</div>
                  </div>
                </li>
              )}
              {c.email && (
                <li className="flex items-start gap-4 border-t border-[#3a3a3a] pt-5" data-testid="contact-email">
                  <Mail className="text-[#FFCC00] flex-shrink-0 mt-1" size={22}/>
                  <div>
                    <div className="font-mono-acc text-[10px] uppercase text-white/50 mb-1">Email</div>
                    <a href={`mailto:${c.email}`} className="font-display text-white text-lg lowercase break-all">{c.email}</a>
                  </div>
                </li>
              )}
              <li className="flex items-start gap-4 border-t border-b border-[#3a3a3a] py-5" data-testid="contact-hours">
                <Clock className="text-[#FFCC00] flex-shrink-0 mt-1" size={22}/>
                <div className="flex-1">
                  <div className="font-mono-acc text-[10px] uppercase text-white/50 mb-2">Godziny otwarcia</div>
                  <ul className="space-y-1 font-mono-acc text-sm text-white/85">
                    {c.hours.map((h, i) => (
                      <li key={i} className="flex justify-between gap-3">
                        <span>{h.day}</span>
                        <span className="text-[#FFCC00]">{h.time}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-3 border border-[#3a3a3a]" data-testid="contact-map">
            <iframe
              title="Mapa Śląski Maker Space"
              src={mapSrc}
              className="w-full h-[520px]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </section>
    </div>
  );
}
